import { connect } from 'react-redux';

import * as Sentry from '@sentry/react';
import { Dispatch } from 'redux';

import Logout from '../../components/templates/Logout';
import { logout } from '../../store/actions';

export interface ILogoutProps {
  callback?: () => void;
  sentryEnabled?: boolean;
}

export default connect(
  undefined,
  (dispatch: Dispatch, { callback = () => {}, sentryEnabled = false }: ILogoutProps) => ({
    onLogout: async () => {
      if (sentryEnabled) {
        if ('getCurrentScope' in Sentry && typeof Sentry.getCurrentScope === 'function') {
          const currentScope = Sentry.getCurrentScope();
          currentScope.clear();
        }
      }
      await dispatch(logout());
      await callback();
      return true;
    },
  })
)(Logout);
